import { getShiftStatusColor } from 'constants/shiftStatusMap';
import { StyledBKJAvatar } from 'components/BKJJaneAvatar/BKJJaneAvatar.styled';
import { IJaneAvatarProps } from './BKJJaneAvatar.types';

export const JaneAvatar = (props: IJaneAvatarProps): JSX.Element => {
  const { status, url, size = 24, pendingSignup, isBlockShift, ...rest } = props;

  return (
    <StyledBKJAvatar
      src={url}
      fallbackAvatarColor={getShiftStatusColor(status, isBlockShift)}
      height={`${size}px`}
      width={`${size}px`}
      size={size}
      fontSize={size}
      status={status}
      showPendingSignUp={pendingSignup}
      {...rest}
    />
  );
};
